var _path, _path2, _rect, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.75 21.924V.75h29.746v21.174H.75Z",
    fill: "url(#web_svg__a)",
    stroke: "url(#web_svg__b)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.166 6.977c0-.245.202-.444.45-.444h9.765c.248 0 .45.199.45.444a.447.447 0 0 1-.45.443H4.616a.447.447 0 0 1-.45-.443Zm0 4.011c0-.245.202-.443.45-.443h14.736c.248 0 .45.198.45.443a.447.447 0 0 1-.45.444H4.616a.447.447 0 0 1-.45-.444Zm0 4.535c0-.245.202-.444.45-.444h5.149c.248 0 .45.199.45.444a.447.447 0 0 1-.45.443H4.616a.447.447 0 0 1-.45-.443Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.97,
    y: 24.418,
    width: 19.884,
    height: 2.791,
    rx: 1.395,
    fill: "url(#web_svg__c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.114 8.043H22.9c-.487 0-.885.412-.885.915v20.127c0 .503.398.915.885.915h12.215c.487 0 .886-.412.886-.915V8.958c0-.503-.399-.915-.886-.915Z",
    fill: "url(#web_svg__d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#web_svg__e)",
    d: "M23.144 10.655h11.773v15.964H23.144z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.98 27.759H27.81a.5.5 0 0 0-.487.503.5.5 0 0 0 .487.503h2.169a.5.5 0 0 0 .487-.503.5.5 0 0 0-.487-.503ZM30.779 9.141h-3.541c-.133 0-.221.092-.221.23 0 .136.088.228.22.228h3.542c.132 0 .22-.092.22-.229s-.088-.229-.22-.229Z",
    fill: "#955FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "web_svg__a",
    x1: -5.951,
    y1: 11.907,
    x2: 10.582,
    y2: 31.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E50F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "web_svg__b",
    x1: -12.263,
    y1: 10.776,
    x2: 2.727,
    y2: 35.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.554
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.231
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "web_svg__c",
    x1: 6.437,
    y1: 27.106,
    x2: 24.854,
    y2: 27.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "web_svg__d",
    x1: 27.077,
    y1: 36.478,
    x2: 43.491,
    y2: 30.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "web_svg__e",
    x1: 19.865,
    y1: 19.257,
    x2: 32.693,
    y2: 31.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBA1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })))));
};
export { SvgWeb as ReactComponent };
export default "data:image/svg+xml;base64,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";